//FIXME the creatAnother button is not displaying!!!!!

import { Button, Box, Heading, Text, theme, ChakraProvider, Stack, VStack, Link} from '@chakra-ui/react';
import { CheckCircleIcon, AddIcon } from '@chakra-ui/icons';
import { useState, useEffect } from 'react';
import JSConfetti from 'js-confetti';

export default function Submitted() {
  document.body.style.background = 'lightyellow';

  useEffect(() => {

    const triggerConfetti = () => {
      const jsConfetti = new JSConfetti();
      jsConfetti.addConfetti({
        emojis: ['📓','📚','⭐️'],
        confettiRadius: 6,
        confettiNumber: 50,
      });
      jsConfetti.addConfetti();
    };

    triggerConfetti();
  }, []);
  
  

  

  return (
    <ChakraProvider theme={theme}>
      <Box textAlign="center" py={10} px={6}>
        <VStack spacing='30px'>
          <VStack spacing="5px">
           <CheckCircleIcon boxSize={'50px'} color={'green.500'} />
        
            <Heading as="h2" size="xl" mt={6} mb={2}>
              Success! Thank you for submitting a review!
            </Heading>
        
            <Text color={'gray.500'}>
              We appreciate you submitting a course review. Your contribution is valued by students and universities in promoting open communication regarding course quality!
            </Text>
          </VStack>
    
          <Stack direction='row' spacing={4}>
            <Button leftIcon={<AddIcon boxSize={4} />} colorScheme='blue' variant='solid'>
              <Link href={'/reviewform'}>
              Create Another Review
              </Link>
            </Button>
          </Stack> 
        </VStack>
      </Box>
    </ChakraProvider>
  );
  }